// import React, { useState, useRef, useEffect } from "react";
// import Pagination from "./pagination";
// import classNames from "classnames";
// import { DownloadTableExcel } from "react-export-table-to-excel";
// import Spinner from "../Spinner";

// const Table = ({
//   data,
//   columns,
//   withColumn,
//   link,
//   excel,
//   openModal,
//   setDataTransfert,
//   loading,
// }) => {
//   const tableRef = useRef(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [data]);
//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const startIndex = (currentPage - 1) * pageSize;
//   const endIndex = startIndex + pageSize;
//   const currentData = data?.slice(startIndex, endIndex);
//   const options = [
//     { value: 10, label: "10" },
//     { value: 20, label: "20" },
//     { value: 50, label: "50" },
//     { value: 100, label: "100" },
//     { value: 200, label: "200" },
//     { value: 500, label: "500" },
//     { value: 1000, label: "1000" },
//     { value: 1500, label: "1500" },
//     { value: 2000, label: "2000" },
//     { value: 2500, label: "2500" },
//     { value: 3000, label: "3000" },
//     { value: 3500, label: "3500" },
//     { value: 4000, label: "4000" },
//     { value: 4500, label: "4500" },
//     { value: 5000, label: "5000" },
//   ];
//   if (loading) {
//     return <Spinner width="w-[100px]" height="h-[100px]" />;
//   }
//   return (
//     <div>
//       {data?.length > 0 ? (
//         <table className="rounded-t-lg" ref={tableRef}>
//           <thead className="rounded-t-lg">
//             <tr>
//               {columns?.map((column) => (
//                 <th
//                   key={column.key}
//                   className={`bg-[#5d55e8] text-white  h-[40px] border  border-white `}
//                 >
//                   {column?.label}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody className="bg-white">
//             {currentData?.map((row, index) => (
//               <tr
//                 key={row?._id}
//                 className={classNames("hover:cursor-pointer")}
//                 onClick={() => {
//                   openModal && openModal();
//                   openModal &&
//                     setDataTransfert({
//                       id: row?._id,
//                       date: row?.createdAt,
//                       code: row?.code,
//                       nameExp: row?.dest_firstname,
//                       prenomExp: row?.dest_lastname,
//                       nameDes: row?.em_firstname,
//                       prenomDes: row?.em_lastname,
//                       amount: row?.amount,
//                       currency: row?.currency,
//                       tel: row?.dest_tel,
//                       status: row?.status,
//                     });
//                 }}
//               >
//                 {columns?.map((column) => (
//                   <td
//                     key={column.key}
//                     className={classNames(
//                       withColumn,
//                       `h-[40px]  border border-white`,
//                       index % 2 === 0 ? "bg-[#DCDCDC]" : ""
//                     )}
//                   >
//                     {column?.customRenderers
//                       ? column?.customRenderers(row)
//                       : row[column.key]}
//                   </td>
//                 ))}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       ) : (
//         <div className="w-full"> Aucune résultat</div>
//       )}
//       {data?.length > 0 && (
//         <div className="flex  justify-end items-center mt-2">
//           {data?.length > 10 && (
//             <select
//               className=" w-[75px] h-[25px] mr-4 border border-[2px] rounded"
//               onChange={(e) => setPageSize(+e?.target?.value)}
//             >
//               {options.map((option) => (
//                 <option
//                   key={option.value}
//                   value={option.value}
//                   className="hover:bg-[#A9A9A9]  hover:cursor-pointer h-[40px] flex items-center justify-center "
//                 >
//                   {option.label}
//                 </option>
//               ))}
//             </select>
//           )}

//           <Pagination
//             currentPage={currentPage}
//             pageSize={pageSize}
//             totalCount={data?.length}
//             onPageChange={handlePageChange}
//           />
//         </div>
//       )}
//       {data?.length > 0 && excel && (
//         <DownloadTableExcel
//           filename="file"
//           sheet="file"
//           currentTableRef={tableRef.current}
//         >
//           <button className="bg-[#5d55e8] w-[150px] h-[40px] rounded mx-auto flex items-center justify-center my-8 ">
//             <span className="text-white font-semibold">Export excel</span>
//           </button>
//         </DownloadTableExcel>
//       )}
//     </div>
//   );
// };

// export default Table;
import React, { useState, useRef, useEffect } from "react";
import Pagination from "./pagination";
import classNames from "classnames";
import { DownloadTableExcel } from "react-export-table-to-excel";
import Spinner from "../Spinner";
import { FnSendSms } from "../../helpers/api";
import { toast } from "react-toastify";

const Table = ({
  data,
  columns,
  withColumn,
  link,
  excel,
  openModal,
  setDataTransfert,
  loading,
  isActions,
  isCheckbox,
  openAlert,
}) => {
  const tableRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]); // ✅ Selected rows state
  const [selectAll, setSelectAll] = useState(false); // ✅ "Select all" state

  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  const handlePageChange = (page) => setCurrentPage(page);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentData = data?.slice(startIndex, endIndex);

  const options = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 200, label: "200" },
    { value: 500, label: "500" },
  ];

  // ✅ Select all only if status = complete or canceled
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (checked) {
      const validRows = currentData
        .filter((row) => row.status === "created" || row.status === "consulted")
        .map((row) => row._id);
      setSelectedRows(validRows);
    } else {
      setSelectedRows([]);
    }
  };

  // ✅ Handle single row select
  const handleRowSelect = (id) => {
    setSelectedRows((prev) => {
      if (prev.includes(id)) {
        return prev.filter((rowId) => rowId !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  // ✅ Keep header checkbox updated
  useEffect(() => {
    if (currentData && currentData.length > 0) {
      const selectableRows = currentData.filter(
        (row) => row.status === "created" || row.status === "consulted"
      );
      const allSelected =
        selectableRows.length > 0 &&
        selectableRows.every((row) => selectedRows.includes(row._id));
      setSelectAll(allSelected);
    }
  }, [selectedRows, currentData]);

  const sendSms = () => {
    FnSendSms({
      userIDs: selectedRows,
    })
      .then((response) => {
        if (response?.success) {
          setSelectedRows([]);
          setSelectAll(false);
          toast("SMS envoyée avec succée", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            type: "success",
          });
        } else {
          toast("Erreur", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            type: "error",
          });
        }
      })
      .catch((err) => {
        toast("Erreur", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          type: "error",
        });
      });
  };
  if (loading) {
    return <Spinner width="w-[100px]" height="h-[100px]" />;
  }

  return (
    <div className="relative">
      {/* ✅ Envoyer button */}
      {selectedRows.length > 0 && (
        <div className="absolute right-0 top-[-50px]">
          <button
            className="bg-[#5d55e8] text-white px-4 py-2 rounded-lg shadow font-semibold"
            onClick={() => sendSms()}
          >
            Envoyer SMS
          </button>
        </div>
      )}

      {data?.length > 0 ? (
        <table className="rounded-t-lg w-full" ref={tableRef}>
          <thead className="rounded-t-lg">
            <tr>
              {/* ✅ Checkbox header */}
              {isCheckbox && (
                <th className="bg-[#5d55e8] text-white border border-white w-[50px]">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </th>
              )}

              {/* ✅ Add a key column */}
              <th className="bg-[#5d55e8] text-white border border-white w-[70px]">
                #
              </th>

              {columns?.map((column) => (
                <th
                  key={column.key}
                  className="bg-[#5d55e8] text-white h-[40px] border border-white"
                >
                  {column?.label}
                </th>
              ))}
              {isActions && (
                <th className="bg-[#5d55e8] text-white border border-white w-[120px]">
                  Actions
                </th>
              )}
            </tr>
          </thead>

          <tbody className="bg-white">
            {currentData?.map((row, index) => {
              const canSelect =
                row?.status === "created" || row?.status === "consulted";
              const isEven = index % 2 === 0;

              return (
                <tr
                  key={row?._id}
                  // className={classNames("hover:cursor-pointer")}
                >
                  {/* ✅ Checkbox per row (only if allowed) */}
                  {isCheckbox && (
                    <td
                      className={classNames(
                        "border border-white text-center",
                        isEven ? "bg-[#DCDCDC]" : ""
                      )}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {canSelect && (
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(row._id)}
                          onChange={() => handleRowSelect(row._id)}
                        />
                      )}
                    </td>
                  )}

                  {/* ✅ Key column (numbered) */}
                  <td
                    className={classNames(
                      "border border-white text-center font-semibold",
                      isEven ? "bg-[#DCDCDC]" : ""
                    )}
                  >
                    {startIndex + index + 1}
                  </td>

                  {columns?.map((column) => (
                    <td
                      key={column.key}
                      className={classNames(
                        withColumn,
                        "h-[40px] border border-white px-2",
                        isEven ? "bg-[#DCDCDC]" : ""
                      )}
                    >
                      {column?.customRenderers
                        ? column?.customRenderers(row)
                        : row[column.key]}
                    </td>
                  ))}
                  {isActions && (
                    <td
                      className={classNames(
                        " border border-white text-center font-semibold w-[180px] ",
                        isEven ? "bg-[#DCDCDC]" : ""
                      )}
                    >
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={() => {
                            openModal && openModal();
                            openModal &&
                              setDataTransfert({
                                id: row?._id,
                                date: row?.createdAt,
                                code: row?.code,
                                nameExp: row?.dest_firstname,
                                prenomExp: row?.dest_lastname,
                                nameDes: row?.em_firstname,
                                prenomDes: row?.em_lastname,
                                amount: row?.amount,
                                currency: row?.currency,
                                tel: row?.dest_tel,
                                status: row?.status,
                              });
                          }}
                          className="w-[70px] rounded  bg-gray-600 p-1 text-sm font-bold text-white hover:bg-gray-700 "
                        >
                          Détails
                        </button>

                        {(row?.status === "created" ||
                          row?.status === "consulted") && (
                          <button
                            onClick={() => openAlert(row?._id)}
                            className="w-[70px] rounded bg-red-600 p-1 text-sm font-bold text-white hover:bg-red-700 "
                          >
                            Annuler
                          </button>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className="w-full text-center py-4">Aucun résultat</div>
      )}

      {/* Pagination + Excel */}
      {data?.length > 0 && (
        <div className="flex justify-end items-center mt-2">
          {data?.length > 10 && (
            <select
              className="w-[75px] h-[25px] mr-4 border border-[2px] rounded"
              onChange={(e) => setPageSize(+e.target.value)}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}

          <Pagination
            currentPage={currentPage}
            pageSize={pageSize}
            totalCount={data?.length}
            onPageChange={handlePageChange}
          />
        </div>
      )}

      {data?.length > 0 && excel && (
        <DownloadTableExcel
          filename="file"
          sheet="file"
          currentTableRef={tableRef.current}
        >
          <button className="bg-[#5d55e8] w-[150px] h-[40px] rounded mx-auto flex items-center justify-center my-8 ">
            <span className="text-white font-semibold">Export excel</span>
          </button>
        </DownloadTableExcel>
      )}
    </div>
  );
};

export default Table;
